<template>
    <!-- 报告列表 -->
    <el-tabs v-model="activeSy" type="border-card" class="tabs-card-three">
        <el-tab-pane name="first" label="尽调报告">
            <el-table class="table-two" :data="reportTable" border>
                <el-table-column label="名称" prop="secuNameAbbr"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="btn-normal">
                            <a class="line_one mainColor" :title="scope.row.secuNameAbbr" :href="'#/report?code='+scope.row.code+'&type='+scope.row.type" target="_blank">阅读</a>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </el-tab-pane>
        <el-tab-pane name="second" label="回访报告"></el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: "reportList",
    data() {
        return {
            activeSy: 'first',
            reportTable: [
                {
                    secuNameAbbr: '尽调报告1',
                    code: '111',
                    type: 'manager',
                }
            ]
        }
    }
}
</script>

<style lang="less" scoped>
</style>